import { useEffect, useState } from "react";
import { Font, FontFace } from "../config";

function getFontFormat(src: string) {
	if (src.endsWith(".woff2")) return "woff2";
	if (src.endsWith(".woff")) return "woff";
	if (src.endsWith(".ttf")) return "truetype";
	if (src.endsWith(".otf")) return "opentype";
	return "";
}

const useFontLoader = (fonts: Font[]) => {
	const [fontsLoaded, setFontsLoaded] = useState(false);

	useEffect(() => {
		let loadedFontsCount = 0;
		const links: (HTMLLinkElement | HTMLStyleElement)[] = [];

		const isAllLoaded = () => {
			if (loadedFontsCount === fonts.length) {
				setFontsLoaded(true);
			}
		};

		const loadFonts = () => {
			fonts.forEach((font) => {
				if (typeof font.fontSrc === "string") {
					// Google Fonts URL: inject <link>

					const linkElement = document.createElement("link");
					linkElement.href = font.fontSrc;
					linkElement.rel = "stylesheet";
					linkElement.onload = () => {
						loadedFontsCount++;
						isAllLoaded();
					};
					linkElement.onerror = () => {
						console.error(`Failed to load font from URL: ${font.fontSrc}`);
						loadedFontsCount++;
						isAllLoaded();
					};
					links.push(linkElement);
					document.head.appendChild(linkElement);
				} else if (typeof font.fontSrc === "object") {
					const fontFaceArr = font.fontSrc as unknown as FontFace[];
					// Local font: inject <style> with @font-face for each file

					const style = document.createElement("style");
					style.innerHTML = fontFaceArr
						.map(
							(fontFace) => `
						@font-face {
						font-family: '${font.fontFamily}';
						src: url('${fontFace.src}') format('${getFontFormat(fontFace.src)}');
						font-weight: ${fontFace.fontWeight};
						font-style: ${fontFace.fontStyle || "normal"};
						}
					`,
						)
						.join("\n");

					links.push(style);
					document.head.appendChild(style);

					loadedFontsCount++;
					isAllLoaded();
				}
			});
		};

		loadFonts();

		return () => {
			links.forEach((link) => {
				document.head.removeChild(link);
			});
		};
	}, [fonts]);

	return { fontsLoaded };
};

export default useFontLoader;
